<template>
    <div>
        <div class="card">
            <div class="fl-te-c">
                <h4 class="mb-3">Gallery Details</h4>
                <btn text="Back" @click="$router.push('/gallery-events/')" size="sm"/>
            </div>

            <edit-gallery-event ref="editForm" v-if="details" :initial-data="details"/>
            <p v-else class="text-center p-3">No data available.</p>
        </div>
        <gallery-event-image @success="loadDetails" :gallery_id="id" :details="details.gallery_images"/>
    </div>
</template>

<script>
import axios from 'secure-axios';
import urls from '../../../../data/urls';
import EditGalleryEvent from './EditGalleryEvent';
import GalleryEventImage from './GalleryEventImageListing';

export default {
    name       : 'DetailsPage',
    components : { GalleryEventImage, EditGalleryEvent },
    data () {
        return {
            loading : false,
            details : '',
            id      : this.$route.params.id
        };
    },
    mounted () {
        this.loadDetails();
    },
    methods : {
        async loadDetails () {
            this.loading = true;
            const response = await axios.form(urls.admin.event.gallery.details, { id : this.id });
            const json = response.data;
            if (json.error === false) {
                this.details = json.data;
            } else {
                this.$notify('Could not load data, Please try again later', 'Error', {
                    type : 'danger'
                });
            }
            this.loading = false;
        }
    }
}
;
</script>

<style scoped>

</style>
